import gql from "graphql-tag";

export const PUBLISHER_ACCOUNT_STATUS = gql`
  query PUBLISHER_ACCOUNT_STATUS($pubId: Int) {
    publisherAccountStatus(assumePubId: $pubId) {
      publisher {
        accountType
      }
      status {
        trialStatus {
          remainingDays
        }
      }
    }

    accountConfig(assumePubId: $pubId) {
      config
    }
  }
`;

export const ACCOUNT_CONFIG = gql`
  query ACCOUNT_CONFIG($pubId: Int) {
    accountConfig(assumePubId: $pubId) {
      config
    }
  }
`;

export const GET_PUBLISHER_ACCOUNT_TYPE = gql`
  query PUBLISHER_ACCOUNT_STATUS($pubId: Int) {
    publisherAccountStatus(assumePubId: $pubId) {
      publisher {
        accountType
      }
    }
  }
`;

export const GET_ME = gql`
  query {
    me {
      userId
      email
      publisher {
        publisherId
        name
        accountType
      }
    }
  }
`;
